'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('servicerequest-ticket-list', {
      url: '/servicerequest/ticket/list',
      template: '<service-request-ticket-list></service-request-ticket-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/servicerequests/ticket-list/servicerequest-ticket-list.routes.js